import authRules from '../authRules.js';

const addAssignmentViewPrices = (user) => {
  const { viewPrices } = user.securityLevels;
  if (viewPrices >= authRules.addAssignmentViewPrices.viewPrices) {
    return true;
  } else
  return false;
}

export default addAssignmentViewPrices;
